<div class="engagement-section">
	<label class="form-label">Upload Engagement Letter (Optional)</label>
	<small class="d-block mb-1 note">PDF files only</small>

	<ng-container *ngIf="file || errorMessage; else fileInput">
		<div class="d-flex flex-column align-items-center engagement-file-wrapper gap-1">
			<i class="fa fa-file fs-3 text-secondary"></i>
			<div class="file-name">{{ file.name }}</div>
			<div class="file-size">{{ getFileSize(file.size) }}</div>

			<div class="position-relative d-inline-block">
				<div 
					class="remove-circle" 
					(click)="removeFile(fileInput)" 
					aria-label="Remove file">
						<i class="pi pi-times"></i>
				</div>

				<label class="btn btn-sm btn-primary mb-0">
					<span>Browse Files</span>
					<input 
						#fileInput 
						type="file" 
						accept=".pdf" 
						(change)="onFileInput($event)" 
						hidden />
				</label>
			</div>

			<div *ngIf="errorMessage" class="text-danger small text-center mt-1">
				{{ errorMessage }}
			</div>
		</div>
	</ng-container>

	<ng-template #fileInput>
		<label class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1">
			<i class="fa fa-arrow-up-from-bracket me-1"></i>
			<span>Browse Files</span>
			<input 
				type="file" 
				accept=".pdf" 
				(change)="onFileInput($event)" 
				hidden />
		</label>
	</ng-template>
</div>